import React, { useEffect, useState } from 'react';
import { IQuestionListItem } from '@/types';
import './index.less';
import { Input, Select } from 'antd';
import classNames from 'classnames';
import { ClozeRightIcon, ClozeSelectIcon, ClozeWrongIcon } from '@/svgs';
import { useTranslation } from 'react-i18next';

interface IProps {
    questionItem: IQuestionListItem;
}

const ClozeTest = (props: IProps) => {
    const { questionItem } = props;
    const { questionSeaClozeContent } = questionItem;
    const { t } = useTranslation();

    const [userMap, setUserMap] = useState<{ [key: string]: string }>({}); // 用户答案
    const [statusMap, setStatusMap] = useState<{ [key: string]: number }>({}); // 答案状态

    // 初始化
    useEffect(() => {
        const userClozeAnswers = questionItem.userAnswer?.userClozeAnswers || [];
        const currentUserMap: { [key: string]: string } = {};
        const currentStatusMap: { [key: string]: number } = {};

        userClozeAnswers.forEach(item => {
            currentUserMap[item.key] = item.userAnswer || t('cloze.noAnswer');
            currentStatusMap[item.key] = item.userAnswerStatus;
        });
        setUserMap(currentUserMap);
        setStatusMap(currentStatusMap);
    }, [questionItem]);

    const retureCloze = (item: IQuestionListItem['questionSeaClozeContent'][number]) => {
        switch (item.type) {
            case 'picture':
                return <img style={{ maxWidth: '100%', verticalAlign: 'middle', margin: 2, borderRadius: 4 }} src={item.picture.link} />;
            case 'text':
                return <span dangerouslySetInnerHTML={{ __html: item.content }} />;
            case 'input':
                return (
                    <Input
                        className={classNames({
                            'sub-tiku__input-wrong': statusMap[item.key] !== 1,
                            'sub-tiku__input-right': statusMap[item.key] === 1,
                        })}
                        disabled
                        value={userMap[item.key] || t('cloze.noAnswer')}
                    />
                );
            case 'select':
                return (
                    <Select
                        className={classNames({
                            'sub-tiku__select-wrong': statusMap[item.key] !== 1,
                            'sub-tiku__select-right': statusMap[item.key] === 1,
                        })}
                        disabled
                        value={userMap[item.key] || t('cloze.noAnswer')}
                    >
                        {item.selectList?.options.map(child => (
                            <Select.Option key={child.value} value={child.value}>
                                {child.label}
                            </Select.Option>
                        ))}
                    </Select>
                );
            case 'radioTable':
                return (
                    <div className="sub-tiku__cloze-radio-tabel-box">
                        <div className="sub-tiku__radio-table-item">
                            <div />
                            {item.radioTableInfo?.dataList.map(child => (
                                <div
                                    className="sub-tiku__radio-table-option"
                                    key={child.key}
                                    dangerouslySetInnerHTML={{ __html: child.label }}
                                />
                            ))}
                        </div>
                        {item.radioTableInfo?.questionListInfo.map(child => {
                            const optionNum = item.radioTableInfo?.dataList.length;
                            const opitonList = Array(optionNum)
                                .fill(0)
                                .map((_, index) => index);
                            return (
                                <div key={child.key} className="sub-tiku__radio-table-item">
                                    <div dangerouslySetInnerHTML={{ __html: child.title.replace('&nbsp;', '') }} />
                                    {opitonList.map(son => {
                                        const isUserChecked = userMap[child.key] === String.fromCharCode(son + 65);
                                        const isRightAnswer = child.rightAnswer === String.fromCharCode(son + 65);
                                        return (
                                            <div className="sub-tiku__single-radio--box" key={String.fromCharCode(son + 65)}>
                                                <div
                                                    className={classNames('sub-tiku__single-radio-option-item', {
                                                        'sub-tiku__right-not-chiecked': !isUserChecked && isRightAnswer,
                                                        'sub-tiku__right-checked': isUserChecked && isRightAnswer,
                                                        'sub-tiku__error-checked': isUserChecked && !isRightAnswer,
                                                    })}
                                                >
                                                    {isUserChecked && isRightAnswer && <ClozeSelectIcon />}
                                                    {isUserChecked && !isRightAnswer && <ClozeWrongIcon />}
                                                    {!isUserChecked && isRightAnswer && <ClozeRightIcon />}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>
                );
            case 'table':
                return (
                    <div className="sub-tiku__cloze-tabel-box" style={{ width: (item.tableInfo?.width || 200) * item.tableInfo!.col }}>
                        {item.tableInfo!.tableList.map(child => (
                            <div
                                key={child.key}
                                className="sub-tiku__cloze-tabel-item"
                                style={{ flexBasis: `${100 / item.tableInfo!.col}%` }}
                            >
                                {child.childList.map(son => (
                                    <span key={son.key}>
                                        {son.type === 'text' && <span dangerouslySetInnerHTML={{ __html: son.content || '' }} />}
                                        {son.type === 'input' && (
                                            <Input
                                                className={classNames({
                                                    'sub-tiku__input-wrong': statusMap[son.key] !== 1,
                                                    'sub-tiku__input-right': statusMap[son.key] === 1,
                                                })}
                                                disabled
                                                value={userMap[son.key] || t('cloze.noAnswer')}
                                            />
                                        )}
                                        {son.type === 'select' && (
                                            <Select
                                                className={classNames({
                                                    'sub-tiku__select-wrong': statusMap[son.key] !== 1,
                                                    'sub-tiku__select-right': statusMap[son.key] === 1,
                                                })}
                                                disabled
                                                value={userMap[son.key] || t('cloze.noAnswer')}
                                            >
                                                {son.selectList?.options.map(child => (
                                                    <Select.Option key={child.value} value={child.value}>
                                                        {child.label}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        )}
                                    </span>
                                ))}
                            </div>
                        ))}
                    </div>
                );
            default:
                break;
        }
    };
    return (
        <div className="sub-tiku__coze-title-view">
            {questionSeaClozeContent.map(item => {
                return <React.Fragment key={item.key}>{retureCloze(item)}</React.Fragment>;
            })}
        </div>
    );
};

export default ClozeTest;
